// Menu order (owner 2026-10-02): Croatian, English, German, other European by speakers, the rest, then Russian, Turkish, Indonesian.
// live = shown in menus; suggest = a device set to it starts there; forgiveAccents: utils/accentInput.js; short = compact-chip name.
export const LANGUAGES = [
    { code: 'hr', name: 'Hrvatski', flag: '\u{1F1ED}\u{1F1F7}', locale: 'hr-HR', live: true, suggest: true },
    { code: 'en', name: 'English', flag: '\u{1F1EC}\u{1F1E7}', locale: 'en-US', live: true, suggest: true },
    { code: 'de', name: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}', locale: 'de-DE', live: true, suggest: true },
    { code: 'es', name: 'Español', flag: '\u{1F1EA}\u{1F1F8}', locale: 'es-419', live: true, suggest: true, forgiveAccents: true },
    { code: 'fr', name: 'Français', flag: '\u{1F1EB}\u{1F1F7}', locale: 'fr-FR', live: true, suggest: true, forgiveAccents: true },
    { code: 'pt', name: 'Português', flag: '\u{1F1E7}\u{1F1F7}', locale: 'pt-BR', pluralLocale: 'pt-PT', live: true, suggest: true },
    { code: 'it', name: 'Italiano', flag: '\u{1F1EE}\u{1F1F9}', locale: 'it-IT', live: true, suggest: true, forgiveAccents: true },
    { code: 'pl', name: 'Polski', flag: '\u{1F1F5}\u{1F1F1}', locale: 'pl-PL', live: true, suggest: true },
    // No country flag (owner 2026-10-01): Russian speakers live in many countries.
    { code: 'ru', name: 'Русский', flag: '\u{1F310}', locale: 'ru-RU', live: true, suggest: true },
    { code: 'tr', name: 'Türkçe', flag: '\u{1F1F9}\u{1F1F7}', locale: 'tr-TR', live: true, suggest: true },
    { code: 'id', name: 'Bahasa Indonesia', short: 'Indonesia', flag: '\u{1F1EE}\u{1F1E9}', locale: 'id-ID', live: true, suggest: true },
];

export const DEFAULT_LANGUAGE = 'en';
export const LIVE_LANGUAGES = LANGUAGES.filter(l => l.live);
export const LANGUAGE_BY_CODE = Object.fromEntries(LANGUAGES.map(l => [l.code, l]));

/** The live languages in menu order with the chosen one first (what every language menu shows). */
export function menuLanguages(selected) {
    return [...LIVE_LANGUAGES].sort((a, b) => (b.code === selected) - (a.code === selected));
}

/** The first device language we can suggest ('de-AT' matches 'de'); English otherwise. */
export function pickLanguage(deviceLanguages) {
    for (const tag of deviceLanguages || []) {
        const code = String(tag).toLowerCase().split('-')[0];
        const lang = LANGUAGE_BY_CODE[code];
        if (lang && lang.live && lang.suggest) return code;
    }
    return DEFAULT_LANGUAGE;
}

export function detectLanguage() {
    if (typeof navigator === 'undefined') return DEFAULT_LANGUAGE;
    return pickLanguage(navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language]);
}

// Addresses: the default language lives at the root (/leaderboard), every other at /<code>/… (/hr/leaderboard).
const LIVE_CODES = LIVE_LANGUAGES.map(l => l.code);
const PREFIX_RE = new RegExp(`^/(${LIVE_CODES.join('|')})(?=/|$)`);

/** The language an address names, or null. '/en/…' is a legacy alias of the root, so it names nothing. */
export function languageFromPath(pathname) {
    const m = PREFIX_RE.exec(pathname || '');
    return m && m[1] !== DEFAULT_LANGUAGE ? m[1] : null;
}

export function basenameFor(lang) {
    return lang === DEFAULT_LANGUAGE || !LIVE_CODES.includes(lang) ? '' : `/${lang}`;
}

/** The same page in `lang`: localizedPath('/hr/leaderboard', 'en') === '/leaderboard'. */
export function localizedPath(pathname, lang) {
    const bare = (pathname || '/').replace(PREFIX_RE, '') || '/';
    const base = basenameFor(lang);
    return base ? (bare === '/' ? `${base}/` : base + bare) : bare;
}

export const SITE_URL = 'https://www.word-labyrinth.com';

/** canonical + hreflang alternates of one page (`pathname` without a language prefix). */
export function alternateLinks(pathname, lang) {
    const url = code => SITE_URL + localizedPath(pathname, code);
    return {
        canonical: url(lang),
        alternates: [
            ...LIVE_LANGUAGES.map(l => ({ hreflang: l.code, href: url(l.code) })),
            { hreflang: 'x-default', href: url(DEFAULT_LANGUAGE) },
        ],
    };
}
